import InterfaceDetails from '../pages/interfaceDetails/index.jsx'
import AlarmSetting from '../pages/alarmSetting/index.jsx'
import ErrorLog from '../pages/errorLog/index.jsx'
import ErrorDetail from '../pages/errorDetail/index.jsx'
import Home from '../pages/home/index.jsx';
import ajaxDetail from '../pages/ajaxDetailPage/index.jsx'
import AjaxPage from '../pages/ajaxPage/index.jsx'
import SlowPage from '../pages/slowPage/index.jsx'
const routes = [
    {
        path: '/apm/home',
        component: Home,
        functionCode: "FUN_MONITOR_VISIT",
        title: '访问页面统计',
        exact: true
    },{
        path: '/apm/home/interfaceDetails',
        component: InterfaceDetails,
        parent:'访问页面统计',
        title: '性能详情',
        exact: true
    }, {
        path: '/apm/alarmSetting',
        component: AlarmSetting,
        title: '报警设置',
        functionCode: "FUN_MONITOR_ALARM_MANAGE",
        exact: true
    }, {
        path: '/apm/errorDetail',
        component: ErrorDetail,
        functionCode: "FUN_MONITOR_ERROR",
        title: '错误概览',
        exact: true
    }, {
        path: '/apm/errorLog',
        component: ErrorLog,
        functionCode: "FUN_MONITOR_ERROR_LOG",
        title: '错误日志',
        exact: true
    }, {
        path: '/apm/ajaxPage',
        component: AjaxPage,
        functionCode: "FUN_MONITOR_AJAX",
        title: 'Ajax',
        exact: true
    },{
        path: '/apm/ajaxPage/ajaxDetail',
        component: ajaxDetail,
        parent:'Ajax',
        title: 'Ajax详情',
        exact: true
    }, {
        path: '/apm/slowPage',
        component: SlowPage,
        functionCode: "FUN_MONITOR_SLOW",
        title: '慢页面追踪',
        exact: true
    },
];

export default routes;
